module.exports = __webpack_public_path__ + "static/media/envelope.13f6cf01.svg";